export default {"src":"/_next/static/media/2025-high-performer.b656f234.svg","height":127,"width":97,"blurWidth":0,"blurHeight":0};